import React from 'react'
import { useQuery } from 'react-query'
import { MainTableRow, CollapsibleTableRow } from '.'
import { TableHeader } from './styles'
import { employeeService } from '../../../services'
import { CenteredSpinner } from 'react-angle-dashboard-components'
import { EmployeePlanInfo } from '../../../interfaces/employee'

export const EmployeePremiumTable = () => {
  const { data, isLoading } = useQuery('getEmployees', () =>
    employeeService.getEmployees()
  )

  const { data: plans, isLoading: isLoadingPlans } = useQuery(
    'getEmployeesPlans',
    () => employeeService.getEmployeePlans()
  )

  return (
    <table style={{ width: '100%' }}>
      <thead className="border-bottom">
        <TableHeader />
        <TableHeader>Name</TableHeader>
        <TableHeader>Age</TableHeader>
        <TableHeader>Dependents</TableHeader>
        <TableHeader>Employer Costs</TableHeader>
        <TableHeader>Employee Costs</TableHeader>
      </thead>
      <tbody>
        {isLoading || isLoadingPlans ? (
          <tr>
            <td colSpan={6} className="py-5">
              <CenteredSpinner />
            </td>
          </tr>
        ) : (
          data?.employees?.map((employee: any) => (
            <EmployeeRow
              employee={employee}
              key={employee.id}
              data={plans[employee.id]}
            />
          ))
        )}
      </tbody>
    </table>
  )
}

const EmployeeRow: React.FC<{ employee: any; data: EmployeePlanInfo }> = ({
  employee,
  data
}) => {
  return (
    <>
      <MainTableRow employee={employee} data={data} />
      <CollapsibleTableRow data={data} />
    </>
  )
}
